import React from 'react';
import { Link } from 'react-router-dom';
import TrustBlocks from './TrustBlocks';
import FaqAccordion from './FaqAccordion';
import PageSEO from './PageSEO';

const RentalApplicationsLanding = () => {
  return (
    <main className="App-main intent-landing">
      <PageSEO title="Online Rental Applications for Landlords | Rentual" description="Accept rental applications online. Tenants submit documents, verify identity, and complete screening through one guided flow." path="/rental-applications" />
      <section className="intent-hero">
        <p className="eyebrow-tag">Rental Applications</p>
        <h1>Collect rental applications the easy way.</h1>
        <p className="hero-subhead">
          Send applicants a clean, mobile-friendly form and move directly into rent payments once approved.
        </p>
        <div className="hero-ctas">
          <Link className="primary-button" to="/register">Start free trial</Link>
          <Link className="ghost-button" to="/pricing">View pricing</Link>
        </div>
      </section>

      <section className="steps-section">
        <p className="eyebrow-tag">Application flow</p>
        <h2>Simple from first click to decision.</h2>
        <div className="steps-grid">
          <article className="step-card">
            <div className="step-number">1</div>
            <h3>Apply</h3>
            <p>Tenants submit an application and documents in minutes.</p>
          </article>
          <article className="step-card">
            <div className="step-number">2</div>
            <h3>Review</h3>
            <p>Landlords compare applicants and request missing info.</p>
          </article>
          <article className="step-card">
            <div className="step-number">3</div>
            <h3>Decide &amp; collect rent</h3>
            <p>Approve the right tenant and turn on payments immediately.</p>
          </article>
        </div>
      </section>

      <section className="capabilities-section">
        <p className="eyebrow-tag">Key features</p>
        <h2>Everything you need to manage applications.</h2>
        <div className="capabilities-grid">
          <article className="capability-card">
            <div className="capability-icon">01</div>
            <h3>Custom questions</h3>
            <p>Collect screening details that matter for your property.</p>
          </article>
          <article className="capability-card">
            <div className="capability-icon">02</div>
            <h3>Status tracking</h3>
            <p>Know exactly where each applicant stands.</p>
          </article>
          <article className="capability-card">
            <div className="capability-icon">03</div>
            <h3>Payments ready</h3>
            <p>Move approved tenants into rent payments in minutes.</p>
          </article>
        </div>
      </section>

      <TrustBlocks />

      <section className="pricing-preview">
        <p className="eyebrow-tag">Pricing</p>
        <h2>Simple plans for Ontario landlords.</h2>
        <div className="pricing-preview-grid">
          <div className="pricing-preview-card">
            <h3>Starter</h3>
            <p>Up to 5 units</p>
            <strong>$19/mo</strong>
          </div>
          <div className="pricing-preview-card">
            <h3>Growth</h3>
            <p>Up to 25 units</p>
            <strong>$59/mo</strong>
          </div>
          <div className="pricing-preview-card">
            <h3>Pro</h3>
            <p>Up to 100 units · Payments included</p>
            <strong>$149/mo</strong>
          </div>
        </div>
        <div className="hero-ctas">
          <Link className="ghost-button" to="/pricing">Compare plans</Link>
        </div>
      </section>

      <section className="faq-section">
        <p className="eyebrow-tag">FAQ</p>
        <h2>Questions about applications?</h2>
        <FaqAccordion items={[
          { question: 'How fast can I set up an application?', answer: 'Most landlords can publish and invite applicants in minutes.' },
          { question: 'Can multiple applicants apply together?', answer: 'Yes. Co-applicants can be included in a single workflow.' },
          { question: 'Is data stored securely?', answer: 'Yes. Files are encrypted in transit and protected with role-based access.' }
        ]} />
      </section>

      <section className="cta-panel">
        <h3>Ready to approve and get paid?</h3>
        <p>Start your free trial and enable rent payments after approval.</p>
        <div className="hero-ctas">
          <Link className="primary-button" to="/register">Start free trial</Link>
          <Link className="ghost-button" to="/contact">Talk to us</Link>
        </div>
      </section>
    </main>
  );
};

export default RentalApplicationsLanding;
